<template>
    <div>
        <Gl_leftmenu />
        <Gl_header />
        <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
        <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
        <div class="content">
            <div class="content-header">
                <Backbutton />
                Редактирование заявки
            </div><br>
            <div class="header-for-input"><b>Информация о заявке</b></div>
            <br>
            <hr /><br>
            ID Заявки: {{ kcop.id }} <br><br>
            Компания: {{ kcop.company }} <br><br>
            Статус заявки: {{ ref_statuses[kcop.status_id] }} <br><br>
            <div class="header-for-input">Эксперт</div>
            <select v-model="expert_id" class="content-input" style="width: 500px !important;" @change="get_criterias()">
                <option v-for="expert in experts" :key="expert.id" :value="expert.id">{{ expert.surname }} {{ expert.name }}</option>
            </select>
            <br><br>
            <table style="min-width: 700px !important;">
                <tr>
                    <th>Код</th>
                    <th>Наименование</th>
                    <th>Оценок (всего) / Аспектов (всего)</th>
                    <th>Оценка / Макс. оценка</th>
                    <th></th>
                </tr>
                <tr v-for="criteria in criterias" :key="criteria.criteria_id">
                    <td>{{ criteria.abbreviation }}</td>
                    <td>{{ criteria.name }}</td>
                    <td>{{ criteria.marks_count }} / {{ criteria.aspects_count }}</td>
                    <td>{{ criteria.marks_sum }} / {{ criteria.aspects_sum }}</td>
                    <td>
                        <Btn_edit @click="$router.push('/kcop_marks/'+id+'/'+criteria.criteria_id+'/'+expert_id)" />
                    </td>
                </tr>
            </table>

            
            
        </div>
    </div>
</template>

<script>

import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'
import Backbutton from '@/components/elements/bacl-button.vue'
import Btn_edit from '@/components/elements/svg/btn_edit.vue'

export default {
    name: 'EditKcop',
    components: {
        Success, Error, Backbutton, Btn_edit
    },
    props: {
        id: String
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            kcop: {
                id: 0,
                company_id: 0,
                user_id: 0,
                company: '',
                inn: '',
                address: '',
                username: '',
                email: '',
                phone: '',
                position: '',
                status_id: '',
                ext_status: '',
            },
            ref_statuses: {
                1: 'На рассмотрении',
                2: 'Зарегистрировано',
                3: 'Отклонено',
            },
            ref_ext_statuses: {
                0: 'Не установлен',
                1: 'Допущено к защите',
                2: 'Победитель конкурсного отбора'
            },
            permissions: {},
            experts: {},
            expert_id: 0,
            criterias: {}
            

        }
    },
    methods: {
        get_kcop() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/kcop/show/'+this.id)
                .then(response => {
                    this.kcop = response.data.data
                    loader.hide();
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        },
        get_experts() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/kcop_marks/experts')
                .then(response => {
                    this.experts = response.data.data
                    loader.hide();
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        },
        get_criterias() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/kcop_marks/criterias/'+this.expert_id+'/'+this.id)
                .then(response => {
                    this.criterias = response.data.data
                    loader.hide();
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        }
    },
    created() {
        this.permissions =  JSON.parse(localStorage.getItem('permissions'))
        this.get_kcop()
        this.get_experts()

        
    }
}

</script>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>